import partition from 'lodash/partition';

const getCutLineData = (players, cutLine) => {
    return partition(players, (obj) => {
        let displayValue = null;
        if(obj.position.displayValue){
            displayValue = !isSpecialStatus(obj) ? parseInt(obj.position.displayValue.replace('T', ''), 10) : obj.position.displayValue;
        }
        else{
            displayValue = '';
        }


        if (isNaN(displayValue) || displayValue === ''){
            if(!isSpecialStatus(obj)){
                return true;
            }
            if(obj.position.sortValue > cutLine){
                return true;
            }
        }

        return displayValue > cutLine;
    });
};

const getStatusData = (players) => {
    return partition(players, (player) => {
        return player.status !== 1;
    });
};

const isSpecialStatus = (player) => {
    return player.position.displayValue === 'WD' || player.position.displayValue === 'RTD' || player.position.displayValue === 'DSQ' || player.position.displayValue === 'DQ';
};

export const splitPlayers = (cutLineState, scoringPlayersCopy, cutLine = null) => {
    let playersAll = [];

    if (cutLineState) {
        playersAll = getCutLineData(scoringPlayersCopy, cutLine);
    } else {
        playersAll = getStatusData(scoringPlayersCopy);
    }

    return playersAll;
};
